import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useCallback, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Form } from '../../styles/styles';
import { SubPageContainer } from '../components/subPageContainer';
const StyledLabel = styled.label `
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
export const ContactUsPage = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const onChangeEmail = useCallback((event) => {
        setEmail(event.target.value);
    }, []);
    const onChangeMessage = useCallback((event) => {
        setMessage(event.target.value);
    }, []);
    const isDisabled = !email || !email.includes('@') || !email.includes('.') || !message;
    // On mobile, we strive to never open the Contact Us page in a new browser tab due to the potential to have
    // no way to close that tab or "go back" to the game, since, if we are running in PWA mode, browser controls
    // aren't available. Therefore, on mobile, we should keep the buttons to let the user back to the entry scene
    // since that may be their only intuitive way back, and we can be fairly confident they don't have an existing
    // game instance in another browser tab:
    const omitHomeLink = !isMobile;
    const omitExtraButtons = !isMobile;
    return (_jsx(SubPageContainer, { title: 'Contact Us', omitHomeLink: omitHomeLink, omitExtraButtons: omitExtraButtons, children: _jsx(Form, { action: 'https://formspree.io/f/xqkvpbar', method: 'POST', children: _jsxs("div", { css: css `
            display: flex;
            flex-direction: column;
            gap: 30px;
          `, children: [_jsx("h2", { css: css `
              color: white;
            `, children: "We'd love to hear from you!" }), _jsxs(StyledLabel, { children: ["Your Email", _jsx(TextField, { type: 'email', name: 'email', value: email, onChange: onChangeEmail, variant: 'filled' })] }), _jsxs(StyledLabel, { children: ["Triplejack Username (optional)", _jsx(TextField, { name: 'username', variant: 'filled' })] }), _jsxs(StyledLabel, { children: ["Message", _jsx(TextField, { name: 'message', multiline: true, rows: 10, value: message, onChange: onChangeMessage, variant: 'filled' })] }), _jsx(Button, { type: 'submit', variant: 'contained', disabled: isDisabled, children: "Send" })] }) }) }));
};
